import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useRef, useEffect } from 'react';
import { useWindowWidth } from '@react-hook/window-size';
export var useSticky = function useSticky(isSticky) {
  var containerRef = useRef();

  var _useState = useState({
    right: 0,
    left: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var windowWidth = useWindowWidth();
  useEffect(function () {
    if (isSticky && containerRef.current) {
      containerRef.current.style.minHeight = "".concat(containerRef.current.offsetHeight, "px");

      var _containerRef$current = containerRef.current.getBoundingClientRect(),
          right = _containerRef$current.right,
          left = _containerRef$current.left;

      setPosition({
        right: window.innerWidth - right,
        left: left
      });
    }
  }, [isSticky, windowWidth, containerRef]);
  return isSticky ? {
    stickyContainerRef: containerRef,
    stickyClassName: 'sticky',
    stickyStyles: _objectSpread({
      width: 'auto !important',
      position: 'fixed !important',
      zIndex: 10,
      top: 0
    }, position)
  } : {};
};
//# sourceMappingURL=use-sticky.js.map